__turbopack_context__.v({
  "className": "bebas_neue_58881f77-module__KnWJqa__className",
});
